import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { images } from 'app/constants/images';

// Component Definition
const MobileLogo: FC = () => {
  const { t } = useTranslation('components');

  return (
    <img
      alt={t('mobileLogo.triumphLogoAltText', 'Triumph Logo')}
      className="mobile-logo"
      src={images.mobileLogoNew.full}
      width={30}
    />
  );
};

export default MobileLogo;
